import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = [
        "container",
        "offer",
        "selection",
        "submit",
        "searchInput",
        "offerList",
        "loading",
        "error",
    ];

    static values = {
        brandid: String,
        storeid: String,
    };

    connect() {
        if (!this.initialOfferListHtml && this.hasOfferListTarget) {
            this.initialOfferListHtml = this.offerListTarget.innerHTML;
        }
        this.refreshOfferList();
    }

    handleOnSelect() {
        const selections = this.selectionTargets;
        const has_selection = selections.some(selection => {
            return selection.checked;
        });
        if (has_selection) {
            this.submitTarget.disabled = false;
            this.submitTarget.classList.remove("is-disabled");
        } else {
            this.submitTarget.disabled = true;
            this.submitTarget.classList.add("is-disabled");
        }
    }

    handleOnSubmit() {
        const selected_offer = this.selectionTargets.find(selection => {
            return selection.checked;
        });

        $(this.element).trigger("scout_offer_select_modal_v2:submit", {
            selected_offer,
        });
    }

    brandidValueChanged() {
        if (!this.initialOfferListHtml) return;
        this.refreshOfferList();
    }

    storeidValueChanged() {
        if (!this.initialOfferListHtml) return;
        this.refreshOfferList();
    }

    preventSubmit(event) {
        event.preventDefault();
    }

    onSearchInput(event) {
        const q = event.target.value;
        clearTimeout(this.debounceTimer);
        this.abortController?.abort();
        if (q.trim() === "" && !this.brandidValue && !this.storeidValue) {
            this.restoreInitialList();
            return;
        }
        if (this.hasLoadingTarget) this.loadingTarget.classList.remove("is-hide");
        if (this.hasOfferListTarget) this.offerListTarget.classList.add("is-hide");
        if (this.hasErrorTarget) this.errorTarget.classList.add("is-hide");
        this.debounceTimer = setTimeout(() => this.performSearch(q), 300);
    }

    restoreInitialList() {
        if (this.hasLoadingTarget) this.loadingTarget.classList.add("is-hide");
        if (this.hasErrorTarget) this.errorTarget.classList.add("is-hide");
        if (this.hasOfferListTarget) {
            this.offerListTarget.innerHTML = this.initialOfferListHtml ?? "";
            this.offerListTarget.classList.remove("is-hide");
        }
        this.resetSubmit();
    }

    refreshOfferList() {
        const q = this.hasSearchInputTarget ? this.searchInputTarget.value : "";
        this.abortController?.abort();
        clearTimeout(this.debounceTimer);
        if (q.trim() === "" && !this.brandidValue && !this.storeidValue) {
            this.restoreInitialList();
            return;
        }
        if (this.hasLoadingTarget) this.loadingTarget.classList.remove("is-hide");
        if (this.hasOfferListTarget) this.offerListTarget.classList.add("is-hide");
        if (this.hasErrorTarget) this.errorTarget.classList.add("is-hide");
        this.performSearch(q);
    }

    async performSearch(q) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        try {
            const url = new URL("/manage/scouts/search_offers", window.location.origin);
            if (q && q.trim() !== "") url.searchParams.set("q", q);
            if (this.brandidValue) url.searchParams.set("brand_id", this.brandidValue);
            if (this.storeidValue) url.searchParams.set("store_id", this.storeidValue);

            const response = await fetch(url, {
                headers: { Accept: "text/html" },
                signal: this.abortController.signal,
            });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const html = await response.text();

            if (this.hasOfferListTarget) {
                this.offerListTarget.innerHTML = html;
                this.offerListTarget.classList.remove("is-hide");
            }
            if (this.hasLoadingTarget) this.loadingTarget.classList.add("is-hide");
            this.resetSubmit();
        } catch (err) {
            if (err.name === "AbortError") return;
            console.error("Scout offer search failed:", err);
            if (this.hasLoadingTarget) this.loadingTarget.classList.add("is-hide");
            if (this.hasOfferListTarget) this.offerListTarget.classList.add("is-hide");
            if (this.hasErrorTarget) this.errorTarget.classList.remove("is-hide");
            this.resetSubmit();
        }
    }

    resetSubmit() {
        if (this.hasSubmitTarget) {
            this.submitTarget.disabled = true;
            this.submitTarget.classList.add("is-disabled");
        }
    }

    onClose() {
        const hadKeyword =
            this.hasSearchInputTarget && this.searchInputTarget.value.trim() !== "";
        if (this.hasSearchInputTarget) {
            this.searchInputTarget.value = "";
        }
        if (hadKeyword) {
            // キーワード検索の結果が残ったままだと、開き直したときに空の検索欄と一覧が食い違うため取り直す
            this.refreshOfferList();
            return;
        }
        clearTimeout(this.debounceTimer);
        this.abortController?.abort();
        this.resetSubmit();
    }
}
